import { Menu } from 'generated/graphql';
import { createContext, useContext } from 'react';
import type { AllMenuHours, QueuedProductImageUpdate } from 'types';

export type AppContextProps = {
  queuedProductImageUpdates: QueuedProductImageUpdate[];
  updateQueuedProductImageUpdates: (updatedQueue: QueuedProductImageUpdate[]) => void;
  draftMenus: Menu[];
  setDraftMenus: (menu: Menu[]) => void;
  modifiedMenuIds: string[];
  setModifiedMenuIds: (menu: string[]) => void;
  setAllMMHours: (hours: AllMenuHours) => void;
  allMMHours: AllMenuHours | null;
};

export const AppContext = createContext<AppContextProps | null>(null);

export const useAppContext = (): AppContextProps => {
  return useContext(AppContext) as AppContextProps;
};
